var _excluded = ["title", "to", "href", "linkTitle", "subtitle", "label", "isAside", "isInactive", "hasCover", "onClick", "onMouseEnter", "onMouseLeave"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import { cover } from "polished";
import styled, { css } from "styled-components";
import OnColorContext from "../../../../../../../../../contexts/OnColorContext";
import getColor from "../../../../../../../../../utils/getColor";
import getTextColor from "../../../../../../../../../utils/getTextColor";
import setSafeHoverStyles from "../../../../../../../../../utils/setSafeHoverStyles";
import space, { spaceFactor } from "../../../../../../../../../utils/space";
import transition from "../../../../../../../../../utils/transition";
import unit from "../../../../../../../../../utils/unit";
import LabelAtm from "../../../../../../../../atoms/LabelAtm";
import TextAtm from "../../../../../../../../atoms/TextAtm";
import { cssTextAtm } from "../../../../../../../../atoms/TextAtm/TextAtm.styled";
import Link from "../../../../../../../../quarks/Link";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 0 4.943 1.058 9.128 5.25H0v1.5h9.128l-4.185 4.193L6 12l6-6-6-6z"
  }));
};
ArrowSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
};
var iconWidth = 12;
var iconMarginLeftSpace = 1.5;
var Arrow = styled(ArrowSvg).withConfig({
  componentId: "sc-vxr42p-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["", ";flex-shrink:0;margin-left:", ";transform:translateX( ", " );opacity:0;fill:", ";"], transition("opacity", "transform"), space(iconMarginLeftSpace), unit(-1 * (iconWidth + iconMarginLeftSpace * spaceFactor)), getColor(theme, "primary"));
});
var Wrapper = styled.div.withConfig({
  componentId: "sc-vxr42p-1"
})(function (_ref2) {
  var $hasCover = _ref2.$hasCover;
  return css(["display:inline-block;position:relative;", ";", ";"], $hasCover && css(["position:unset;"]), setSafeHoverStyles(css(["", "{transform:initial;opacity:1;}"], Arrow)));
});
var TitleWrapper = styled.div.withConfig({
  componentId: "sc-vxr42p-2"
})(["display:flex;align-items:center;&:not(:last-child){margin-bottom:", ";}"], space(0.5));
var Title = styled(Link).withConfig({
  componentId: "sc-vxr42p-3"
})(function (_ref3) {
  var $hasLabel = _ref3.$hasLabel,
    $isAside = _ref3.$isAside,
    $isInactive = _ref3.$isInactive,
    $onColor = _ref3.$onColor,
    theme = _ref3.theme;
  return css(["", ";", ";text-decoration:none;&:before{", ";content:\"\";}", ";", ";span{margin-right:", ";}"], transition("color"), cssTextAtm({
    typography: $isAside ? "small2" : "small3",
    onColor: $onColor,
    emphasis: $isAside ? "medium" : "high"
  }), cover(), $isInactive && css(["color:", ";"], getTextColor(theme, $onColor, "medium")), $isAside && setSafeHoverStyles(css(["", ";"], cssTextAtm({
    typography: "small3",
    onColor: $onColor,
    emphasis: "high"
  }))), $hasLabel && space(0.5));
});
function PointerLinkMol(_ref4) {
  var title = _ref4.title,
    to = _ref4.to,
    href = _ref4.href,
    linkTitle = _ref4.linkTitle,
    subtitle = _ref4.subtitle,
    label = _ref4.label,
    isAside = _ref4.isAside,
    isInactive = _ref4.isInactive,
    hasCover = _ref4.hasCover,
    onClick = _ref4.onClick,
    onMouseEnter = _ref4.onMouseEnter,
    onMouseLeave = _ref4.onMouseLeave,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $hasCover: !!hasCover
  }, restProps), /*#__PURE__*/React.createElement(TitleWrapper, null, /*#__PURE__*/React.createElement(Title, {
    to: to,
    href: href,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    title: linkTitle,
    $hasLabel: !!label,
    $isAside: !!isAside,
    $isInactive: !!isInactive,
    $onColor: onColor
  }, /*#__PURE__*/React.createElement("span", null, title), label ? /*#__PURE__*/React.createElement(LabelAtm, {
    size: "small",
    variant: "notify"
  }, label) : null), /*#__PURE__*/React.createElement(Arrow, null)), subtitle ? /*#__PURE__*/React.createElement(TextAtm, {
    typography: "nano1",
    emphasis: "medium"
  }, subtitle) : null);
}
export default PointerLinkMol;